import { getCurrentWeek, getMonday } from "../../legacyUtils";
import { startOfDay } from "date-fns";
import { WeekType } from "../../../../modal/ConsultationModals/Content/modal";
import i18n from "i18next";

function addDays(date: Date, days: number) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

function isNextYear(year: number) {
    const currentYear = new Date().getFullYear();
    return year === currentYear + 1;
}

export function generateWeek(weekDiff: number) {
    const output = [];
    const mondayDate = startOfDay(getMonday(addDays(new Date(), weekDiff * 7)));
    const mondayYear = mondayDate.getFullYear();

    for (let i = 0; i < 7; i++) {
        const date = addDays(mondayDate, i);
        let year = date.getFullYear();

        // const week =
        //     year > mondayYear
        //         ? 1
        //         : isNextYear(year)
        //         ? getCurrentWeek(date) + 1
        //         : getCurrentWeek(date);

        // const week = year > mondayYear ? 0 : getCurrentWeek(date);
        const week = getCurrentWeek(date);
        let month = date.getMonth();

        if (week == 1 && month == 11) {
            year = year + 1;
        }

        if ((week == 53 || week == 52) && month == 0) {
            year = year - 1;
        }

        output.push({
            date,
            name: date.toLocaleDateString("en-EN", {
                weekday: "long",
            }),
            dateString: date.toLocaleDateString("en-EN", {
                month: "2-digit",
                day: "2-digit",
            }),
            year: year,
            week,
            index: i,
            weekType: (week % 2 === 0 ? "even" : "odd") as WeekType,
        });
    }

    // let lastWeek = output.find((o) => o.week === 52);
    // let firstWeek = output.find((o) => o.week === 1);

    // if (lastWeek && firstWeek) {
    //     let _output = output.map((o) => {
    //         let year = firstWeek!.year;
    //         return {
    //             ...o,
    //             week: 1,
    //             year: year,
    //         };
    //     });
    //     return _output;
    // }

    return output;
}

export function getWeekInterval(weekDiff: number) {
    const monday = getMonday(addDays(new Date(), weekDiff * 7));
    const sunday = addDays(monday, 6);

    return [monday, sunday] as const;
}

export function formatWeekInterval([monday, sunday]: readonly [Date, Date]) {
    const format = (date: Date) =>
        date.toLocaleDateString(i18n.language === "hu" ? "hu-HU" : "en-EN", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });

    return `${format(monday)} - ${format(sunday)}`;
}
